import { api, handleResponse, handleError } from "./apiServices";

export const getReport = (token, data) =>
  api(token)
    .get("/api/reports/generate/", { params: data })
    .then(handleResponse)
    .catch(handleError);

export const generateCsvFile = (token, data) => {
  console.log("data", data);
  return api(token)
    .post("/api/reports/generate/generate-csv", data)
    .then(handleResponse)
    .catch(handleError);
};
